import React, { createContext, useContext, useState } from 'react';
import en from './en';
import hi from './hi';
import es from './es';
import ru from './ru';

// add new languages here
const languages = { en, hi, es, ru };

const I18nContext = createContext({
  locale: 'en',
  setLocale: () => {},
  strings: en,
});

function detectBrowserLocale(available = []) {
  if (typeof navigator === 'undefined') return null;
  const langs = navigator.languages || [navigator.language || 'en'];
  for (const l of langs) {
    const prefix = l.split('-')[0];
    if (available.includes(prefix)) return prefix;
  }
  return null;
}

export function LanguageProvider({ children, defaultLocale = 'en' }) {
  const available = Object.keys(languages);
  // Always prefer browser-detected locale at startup. Do not persist an explicit
  // user choice to localStorage — the app will follow the browser preference
  // automatically each load. We still expose a setter to override at runtime
  // (non-persistent).
  const detected = detectBrowserLocale(available);
  const initial = detected || defaultLocale;

  const [locale, _setLocale] = useState(initial);

  // setLocale allows programmatic override for the current session only
  const setLocale = (next) => {
    if (available.includes(next)) {
      _setLocale(next);
    }
  };

  const value = { locale, setLocale, strings: languages[locale] || en };
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  return useContext(I18nContext);
}

export function useStrings() {
  const ctx = useContext(I18nContext);
  return ctx.strings;
}

export const availableLocales = Object.keys(languages);

export default languages;
